/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type SearchOrganizationType = typeof SearchOrganizationType[keyof typeof SearchOrganizationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchOrganizationType = {
  cases: 'cases',
  documents: 'documents',
  all: 'all',
} as const;
